import { registerServiceWorker } from '@ps-refarch-ux/mfe-utils';
import { shouldRegisterPortalServiceWorker } from './local-dev-auth/storage';
import {
  unregisterPortalServiceWorkersAndClearCaches,
  waitForPortalServiceWorkerController
} from './local-dev-auth/service-worker';

function bootstrapPortal(): void {
  import('./bootstrap');
}

function bootstrapPortalWithoutServiceWorker(): void {
  unregisterPortalServiceWorkersAndClearCaches()
    .catch((error) => {
      console.warn('[Portal index.tsx] Failed to clear existing service workers before bootstrap:', error);
    })
    .finally(() => {
      bootstrapPortal();
    });
}

console.log('[Portal index.tsx] Starting — navigator.serviceWorker.controller:', navigator.serviceWorker?.controller);

if (!shouldRegisterPortalServiceWorker()) {
  bootstrapPortalWithoutServiceWorker();
} else {
  registerServiceWorker('service-worker.js')
    .then((reg) => {
      console.log('[Portal index.tsx] registerServiceWorker resolved', {
        controller: navigator.serviceWorker.controller,
        regActive: reg?.active?.state,
        regInstalling: reg?.installing?.state,
        regWaiting: reg?.waiting?.state,
        scope: reg?.scope
      });
      return navigator.serviceWorker.ready;
    })
    .then(async (readyReg) => {
      console.log('[Portal index.tsx] serviceWorker.ready resolved', {
        controller: navigator.serviceWorker.controller,
        activeState: readyReg.active?.state,
        scope: readyReg.scope
      });
      const hasController = await waitForPortalServiceWorkerController();
      console.log('[Portal index.tsx] service worker controller check resolved', {
        controller: navigator.serviceWorker.controller,
        hasController
      });
      bootstrapPortal();
    })
    .catch((error) => {
      console.warn('[Portal index.tsx] Service worker registration failed:', error);
      bootstrapPortal();
    });
}

export {};
